import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { track } from "../lib/analytics";
import { Seo } from "../components/site/Seo";

const Shell = ({ title, children, testId }) => (
  <div className="container-news max-w-xl py-16" data-testid={testId}>
    <Seo title={title} noindex />
    <p className="kicker mb-2">Newsletter</p>
    <h1 className="hl text-[2rem]">{title}</h1>
    <div className="mt-6 text-[15px]">{children}</div>
  </div>
);

const useTokenAction = (path, onOk, manual = false) => {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: manual ? "ask" : "busy" });
  const token = params.get("token");
  const run = () => {
    if (!token) { setState({ status: "error", msg: "Link nije potpun." }); return; }
    setState({ status: "busy" });
    api.post(path, { token }).then((r) => { setState({ status: "ok", data: r.data }); onOk?.(r.data); })
      .catch((e) => setState({ status: "error", msg: errMsg(e) }));
  };
  useEffect(() => {
    if (!manual) run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  return [state, run];
};

export function NewsletterConfirm() {
  const [s] = useTokenAction("/public/newsletter/confirm", () => track("newsletter_signup", { method: "double_opt_in" }));
  return (
    <Shell title="Potvrda prijave" testId="newsletter-confirm-page">
      {s.status === "busy" && <p>Potvrđujemo…</p>}
      {s.status === "ok" && <div data-testid="newsletter-confirmed"><p className="font-semibold">Prijava je potvrđena. Hvala!</p><p className="mt-2 text-muted-foreground">Odjava je moguća u svakom trenutku putem linka: <Link className="underline" to={`/newsletter/odjava?token=${s.data.unsubscribe_token}`} data-testid="newsletter-unsub-link">odjavi me</Link>. Sačuvaj ovaj link.</p></div>}
      {s.status === "error" && <p className="text-destructive" data-testid="newsletter-confirm-error">{s.msg}</p>}
    </Shell>
  );
}

export function NewsletterUnsubscribe() {
  const [s, run] = useTokenAction("/public/newsletter/unsubscribe", null, true);
  return (
    <Shell title="Odjava s newslettera" testId="newsletter-unsub-page">
      {s.status === "ask" && <button onClick={run} className="h-11 rounded-sm bg-navy px-5 text-sm font-bold text-white dark:bg-pulse" data-testid="newsletter-unsub-confirm">Potvrdi odjavu</button>}
      {s.status === "busy" && <p>Odjavljujemo…</p>}
      {s.status === "ok" && <p data-testid="newsletter-unsubscribed">Odjavljen/a si. Više nećeš primati newsletter.</p>}
      {s.status === "error" && <p className="text-destructive" data-testid="newsletter-unsub-error">{s.msg}</p>}
    </Shell>
  );
}

export const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [hp, setHp] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      setMsg((await api.post("/public/newsletter/subscribe", { email, consent, website: hp })).data.message);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  if (msg) return <p className="mt-4 text-[14px] font-semibold" data-testid="newsletter-success">{msg}</p>;
  return (
    <form onSubmit={submit} className="mt-4 space-y-3" data-testid="newsletter-form">
      <div className="flex flex-col gap-2 sm:flex-row">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vas@email.de" aria-label="Email za newsletter" className="h-11 flex-1 rounded-sm border border-input bg-background px-3 text-sm" data-testid="newsletter-email-input" />
        <input type="text" tabIndex={-1} autoComplete="off" value={hp} onChange={(e) => setHp(e.target.value)} className="hidden" aria-hidden />
        <button disabled={busy || !consent} className="h-11 rounded-sm bg-navy px-5 text-sm font-bold text-white transition-colors hover:bg-navy-700 disabled:opacity-50 dark:bg-pulse" data-testid="newsletter-submit-button">{busy ? "Šaljem…" : "Prijavi me"}</button>
      </div>
      <label className="flex gap-2 text-[12.5px] text-muted-foreground"><input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" data-testid="newsletter-consent-checkbox" />
        <span>Želim primati sedmični newsletter. Prijavu potvrđujem putem emaila; odjava je moguća u svakom emailu. <Link to="/datenschutz" className="underline" lang="de">Datenschutz</Link></span></label>
      {err && <p role="alert" className="text-sm text-destructive" data-testid="newsletter-error">{err}</p>}
    </form>
  );
};
